import { StudyEntityType, Variant } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { variantClient, VariantPathParameters } from './VariantClient';

const factory = createStudyEntityHookFactory<Variant, VariantPathParameters>(StudyEntityType.Variant);
export const useVariants = factory.list(variantClient.list);
export const useVariant = factory.get(variantClient.get);
